var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/anonymous/Desktop/components/BottomLink.js",
  _this = this;
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon } from '@sm/wds-react';
export var BottomLink = function BottomLink(_ref) {
  var title = _ref.title,
    url = _ref.url,
    alignment = _ref.alignment;
  return /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    color: "link",
    variant: "text",
    className: "sm-nav-submenu__button wds-float--".concat(alignment),
    href: url,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 5
    }
  }, title, /*#__PURE__*/React.createElement(Icon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 7
    }
  }, "]"));
};
export default BottomLink;
BottomLink.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  alignment: PropTypes.string.isRequired
};
//# sourceMappingURL=BottomLink.js.map